<template>
    <div style="height: 100%">
        <!--    <el-tabs type="border-card" stretch @tab-click="change" v-model="tabsValue" v-if="show">-->
        <el-tabs stretch @tab-click="change" v-model="tabsValue" v-if="show">
            <!--      <el-tab-pane v-for="item in tabList.pages" :key="item" :label="item.label">-->
            <el-tab-pane v-for="item in tabList.pages" :key="item">
                <template #label>
                  <span class="custom-tabs-label" style="font-family: 微软雅黑">
                    <i class="el-icon-s-home"></i>
                    <span>{{ item.label }}</span>
                  </span>
                </template>
            </el-tab-pane>
        </el-tabs>
      <keep-alive :include="['tableView','chartView','fenceView','decreasingContrast']" :max="10">
        <component v-for="item in templateInfo" :key="item" :is="item.showWhat==''?'decreasingContrast':item.showWhat" :templateInfo="item"></component>
      </keep-alive>
<!--        <div>-->
<!--            <el-card class="box-card" :style="{'margin-bottom':templateInfo.length>1?'25px':'0'}" v-for="(item,index) in templateInfo" :key="item">-->
<!--                <div v-if="templateInfo.length>1">-->
<!--                    <span v-if="!item.isShow">{{item.label}}</span>-->
<!--                    <el-button class="cardButton" size="small" text @click.stop="tabShow(index)">{{item.isShow==true?"隐藏":"展开"}}</el-button>-->
<!--                </div>-->
<!--                &lt;!&ndash;:style="{height:$store.state.busVueHeight[index]===undefined?'800px':$store.state.busVueHeight[index]+100+'px'}"&ndash;&gt;-->
<!--                <div   :style="{height:$store.state.busVueHeight[index]===undefined?'800px':$store.state.busVueHeight[index]+100+'px'}" v-if="item.isShow">-->
<!--                    <keep-alive :include="['tableView','chartView','fenceView','decreasingContrast']" :max="10">-->
<!--                        <component  :is="item.showWhat==''?'decreasingContrast':item.showWhat" :templateInfo="item" :templateIndex="index"></component>-->
<!--                    </keep-alive>-->
<!--                </div>-->
<!--            </el-card>-->
<!--        </div>-->
    </div>
</template>
<script>
  import axios from "axios";
  import ChartView from '@/components/ChartView.vue';
  import tableView from '@/components/tableView.vue';
  import FenceView from "@/components/FenceView";
  import decreasingContrast from "@/components/decreasingContrast";
  //import gqDirectoryUploader from '@/components/gqDirectoryUploader.vue';
  export default {
    name: "busView",
    components: {
      ChartView,
      tableView,
      FenceView,
      decreasingContrast
      //gqDirectoryUploader
    },
    data() {
      return {
        templateInfo:[],//处理数据
        busType: "",//数据类型
        tabsValue: 0,
        tabList: [],//查询数据
        showWhat: "",
        show: false
      }
    },
    mounted() {
      this.knowThis();
    },
    methods: {
      async knowThis() {
        let _this = this;
        console.log(this.$route.name);
        if (_this.$route.name!="1-8"){
          this.$store.state.wellDataHome = [];//清空首页检索数据
        }
        let localIpStr = localStorage.getItem("userLocalIP");
        if (localIpStr == null) localIpStr = "127.0.0.1";
        let jwtSession = localStorage.getItem("lyqtJwt");
        if (jwtSession == null) jwtSession = "";
        await axios({
          url:process.env.VUE_APP_SERVER + "/dataprovider/systemdata/module/route/template/" + `${this.$route.name}`,
          headers: {
            "Authorization": "Bearer " + jwtSession,
            "userIP": localIpStr
          },
          method: 'GET'})
          .then(res => {
            console.log("==========================", res.data.content)
            _this.tabList = res.data.content;
            console.log("tabList", this.tabList)
            this.change();
            // _this.templateInfo = res.data.content;
            // _this.busType = _this.templateInfo.type;
          }).catch(err => {
            console.log(err)
          })
      },
      //切换是否隐藏
      tabShow(data){
        this.templateInfo[data].isShow = !this.templateInfo[data].isShow
      },
      //默认触发第一个tabs
      change(newName) {
        console.log(newName)
        console.log(this.tabsValue)
        if(this.tabList!=null){
          //单页面多报表  纵向展示
          if(this.tabList.display=="Vertical"){
            this.templateInfo = [];
            for(let i=0;i<this.tabList.pages.length;i++){
              this.busType = this.tabList.pages[i].type;
              this.templateInfo.push(this.tabList.pages[i]);
              this.templateInfo[i].moduleid = this.tabList.moduleid;
              this.templateInfo[i].modulename = this.tabList.modulename;
              if (this.busType == "chart") {
                this.showWhat = "ChartView"
              }
              if (this.busType == "table") {
                this.showWhat = "tableView"
              }
              if (this.busType == 'fence') {
                this.showWhat = 'fenceView'
              }
              if (this.busType == 'decreasingContrast') {
                this.showWhat = 'decreasingContrast'
              }
              this.templateInfo[i].showWhat = this.showWhat;
              this.templateInfo[i].isShow = false;
              // this.templateInfo.push(this.tabList.pages[this.tabsValue]);
              // this.templateInfo[1].moduleid = this.tabList.moduleid;
              // this.templateInfo[1].modulename = this.tabList.modulename;
              console.log("看看tabList都有啥！！！！-------:", this.tabList)
              console.log("看看template数组做好了没!!!!!!!!!!!!!!!",this.templateInfo)
            }
            this.templateInfo[0].isShow = true;
          }
          //单模块多页面  横向展示
          if(this.tabList.display=="Horizontal"||this.tabList.display == null){
            this.templateInfo = [];
            this.busType = this.tabList.pages[this.tabsValue].type;
            this.templateInfo.push(this.tabList.pages[this.tabsValue]);
            this.templateInfo[0].moduleid = this.tabList.moduleid;
            this.templateInfo[0].modulename = this.tabList.modulename;
            this.templateInfo[0].pageCnt = this.tabList.pages.length;
            console.log("准备前看",this.templateInfo,this.busType,this.showWhat)
            if (this.busType.indexOf("chart") != -1) {
              this.showWhat = "ChartView"
            }
            if (this.busType.indexOf("table") != -1) {
              this.showWhat = "tableView"
            }
            if (this.busType == 'fence') {
              this.showWhat = 'fenceView'
            }
            if (this.busType == 'decreasingContrast') {
              this.showWhat = 'decreasingContrast'
            }
            this.templateInfo[0].showWhat = this.showWhat;
            this.templateInfo[0].isShow = true;
            console.log("tabList模块列表：:", this.tabList)
            console.log("template页面配置：", this.templateInfo)
            console.log("页面类型：", this.busType, this.showWhat)
            console.log("tabList_moduleid：", this.$store.state.tabList_moduleid)
            //根据模块id是否相同来判断是否切换模块
            if (this.$store.state.tabList_moduleid != this.tabList.moduleid) {
              //切换模块：记录当前模块id，不使用保留时间，清空保留时间
              this.$store.state.tabList_moduleid = this.tabList.moduleid;
              this.$store.state.keepTime = false;
              this.$store.state.frameTime = [];
            }
            else {
              this.$store.state.keepTime = true;
            }
          }
        }
      }
    },
    watch: {
      $route: {
        handler(val, oldval) {
          console.log("新", val);//新路由信息
          console.log("老", oldval);//老路由信息
          this.tabsValue = 0;
          this.knowThis(0);
        },
        deep: true
      },
      busType: {
        handler() {
          if (this.busType == "chart") {
            this.showWhat = "ChartView"
          }
          if (this.busType == "table") {
            this.showWhat = "tableView"
          }
          if (this.busType == 'fence') {
            this.showWhat = 'fenceView'
          }
          if (this.busType == 'decreasingContrast') {
            this.showWhat = 'decreasingContrast'
          }
        },
        deep: true
      },
      tabList: {
        handler() {
          if (this.tabList!=null && this.tabList.pages.length != 1 && this.tabList.display == "Horizontal") {
            this.show = true;
          } else {
            this.show = false;
          }
        },
        deep: true
      },
      '$store.state.busVueHeight':{
        handler() {
          console.log(1111111111111,this.$store.state.busVueHeight)
        },
        deep: true
      }

    }


  }
</script>

<style scoped>
    /deep/.el-tabs__content {
        padding: 0 15px;
    }
    .cardButton{
        float:right;
    }

    /deep/.el-tabs__item.is-active {
        color: #409EFF;
        background-color: white;
    }
    /deep/.el-tabs__item {
        background-color: #EEEEEE;
        height: 40px;
        right: 0;
        top: 5px;
        margin-right: 10px;

        /*padding: 0 20px;*/
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        line-height: 40px;
        display: inline-block;
        list-style: none;
        font-size: 16px;
        font-weight: 500;
        /*color: #303133;*/
        /*color: gray;*/
        position: relative;

        /*-webkit-appearance: none;*/
        /*background: none;*/
        border-radius: 10px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        /*font-size: 15px;*/
        /*height: 28px;*/
        /*line-height: 28px;*/
        outline: 0;
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        /*width: 100%;*/
    }
    /deep/.el-tabs__item:hover {
        color: #409EFF;
        cursor: pointer;
    }
    /deep/.el-tabs__active-bar {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        /*background-color: #409EFF;*/
        background: none;
        z-index: 1;
        transition: transform .3s cubic-bezier(.645,.045,.355,1),-webkit-transform .3s cubic-bezier(.645,.045,.355,1);
        list-style: none;
    }
</style>
<style>
    /*.tabContainer {*/
    /*  width: 1200px;*/
    /*  height: auto;*/
    /*  margin: 0 auto;*/
    /*  background: #D4E3FB;*/
    /*  position: relative;*/
    /*}*/
    /*.tabContainer .el-tabs--border-card{*/
    /*  border: none;*/
    /*  -webkit-box-shadow: none;*/
    /*  box-shadow: none;*/
    /*}*/
    /*.tabContainer > .el-tabs--border-card > .el-tabs__header {*/
    /*  !**!*/
    /*  background-color: #1B2945;*/
    /*  border: none;*/
    /*  border-top: 1px solid #1B2945;*/
    /*  border-radius: 3px;*/
    /*  margin: 0;*/
    /*}*/
    /*.tabContainer .el-tabs--border-card>.el-tabs__header .el-tabs__item{*/
    /*  color: #FFFFFF;*/
    /*  text-align: center;*/
    /*  border: none;*/
    /*  min-width: 80px;*/
    /*}*/
    /*.tabContainer .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {*/
    /*  color: #1B2945;*/
    /*  background-color: #FFF;*/
    /*  !*border-right-color: #DCDFE6;*!*/
    /*  !*border-left-color: #DCDFE6;*!*/
    /*  border: none;*/
    /*  box-shadow: none;*/
    /*}*/
    /*.el-tabs--border-card > .el-tabs__content {*/
    /*  margin: 0;*/
    /*  padding: 0;*/
    /*  height: 0;*/
    /*}*/
    /*.tabContainer .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {*/
    /*  color: #409EFF;*/
    /*  !*color: #FFFFFF;*!*/
    /*}*/
    /*!*input*!*/
    /*.tabContainer .tabInput {*/
    /*  background: none;*/
    /*  width: 160px;*/
    /*  height: 28px;*/
    /*  position: absolute;*/
    /*  right: 0;*/
    /*  top: 5px;*/
    /*  margin-right: 10px;*/
    /*}*/
    /*.tabContainer .el-input__inner {*/
    /*  -webkit-appearance: none;*/
    /*  background: none;*/
    /*  border-radius: 4px;*/
    /*  border: 1px solid #DCDFE6;*/
    /*  -webkit-box-sizing: border-box;*/
    /*  box-sizing: border-box;*/
    /*  color: #606266;*/
    /*  display: inline-block;*/
    /*  font-size: 15px;*/
    /*  height: 28px;*/
    /*  line-height: 28px;*/
    /*  outline: 0;*/
    /*  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);*/
    /*  width: 100%;*/
    /*}*/
    /*.tabContainer .el-input__icon {*/
    /*  height: 100%;*/
    /*  width: 25px;*/
    /*  text-align: center;*/
    /*  -webkit-transition: all .3s;*/
    /*  transition: all .3s;*/
    /*  line-height: 28px;*/
    /*}*/
    /*.el-tabs__nav {*/
    /*  white-space: nowrap;*/
    /*  position: relative;*/
    /*  border-bottom: 2px solid gray;*/
    /*  transition: transform .3s,-webkit-transform .3s;*/
    /*  float: left;*/
    /*  z-index: 1;*/
    /*}*/
</style>
